var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-store-locator-list-item",
      class: { "rb-store-locator-list-item--selected": _vm.isSelected },
      attrs: {
        "data-element-id": "X_X_Store_Choose",
        "aria-label":
          "store details card. " +
          _vm.getStoreName +
          ". " +
          _vm.getStoreAddress +
          ". " +
          _vm.getOpeningHours,
        tabindex: "0",
      },
      on: {
        click: _vm.onSelectedStore,
        keypress: [
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onSelectedStore($event)
          },
          function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onSelectedStore($event)
          },
        ],
      },
    },
    [
      _c("span", {
        staticClass: "rb-store-locator-list-item__store-icon common__icon",
        class: _vm.getIcon,
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rb-store-locator-list-item__details" },
        [
          _c("span", { staticClass: "rb-store-locator-list-item__name" }, [
            _vm._v(_vm._s(_vm.getStoreName)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "rb-store-locator-list-item__address" }, [
            _vm._v(_vm._s(_vm.getStoreAddress)),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "rb-store-locator-list-item__opening-hours" },
            [_vm._v(_vm._s(_vm.getOpeningHours))]
          ),
          _vm._v(" "),
          !!_vm.appointmentBookingUrl
            ? _c(
                "button",
                {
                  staticClass: "rb-store-locator-list-item__link",
                  attrs: { tabindex: "0" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.onAppointmentBookingClick($event)
                    },
                    keypress: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.onAppointmentBookingClick($event)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.onAppointmentBookingClick($event)
                      },
                    ],
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.translation(
                          "store_locator.list_item.book_an_appointment"
                        )
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isMobile
            ? [
                _vm.getTelephoneNumber
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "rb-store-locator-list-item__telephone-number",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "common__icon common__icon--telephone",
                          },
                          [_vm._v("phone")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "rb-store-locator-list-item__number",
                            attrs: {
                              tabindex: "0",
                              role: "link",
                              "aria-label":
                                "store phone number - select to call the store",
                            },
                            on: {
                              click: _vm.callStore,
                              keypress: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "space",
                                      32,
                                      $event.key,
                                      [" ", "Spacebar"]
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.callStore($event)
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                  return _vm.callStore($event)
                                },
                              ],
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.getTelephoneNumber) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "rb-store-locator-list-item__directions" },
                  [
                    _c(
                      "span",
                      { staticClass: "common__icon common__icon--arrow-right" },
                      [_vm._v("directions")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "rb-store-locator-list-item__direction-link",
                        attrs: {
                          tabindex: "0",
                          role: "link",
                          "aria-label":
                            "get store directions on a separate window",
                        },
                        on: {
                          click: _vm.showStoreDirectionsOnSeparateMap,
                          keypress: [
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "space",
                                  32,
                                  $event.key,
                                  [" ", "Spacebar"]
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.showStoreDirectionsOnSeparateMap(
                                $event
                              )
                            },
                            function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.showStoreDirectionsOnSeparateMap(
                                $event
                              )
                            },
                          ],
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.translation(
                                "store_locator.list_item.get_direction"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rb-store-locator-list-item__icon" }, [
      _c("span", { staticClass: "common__icon common__icon--arrow-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }